import React from 'react';
import cx from 'classnames';
import T from 'prop-types';
import reactHtmlParser from 'react-html-parser';
import { imgType } from 'types';
import * as styled from './styled';
import styles from './about.css';

const TextBlock = ({ colors, content, linkColor }) => {
  const strippedTitle = content.title.replace(/^\s+/, '');

  return (
    <div
      className={cx(
        styles.textBlockWrapper,
        !strippedTitle && styles.textBlockNoTitle,
        !!Number(content.nomargin) && styles.noMargin,
      )}
    >
      <div className={cx(styles.textBlock)}>
        <div className={styles.titleWrapperDesktop}>
          {content.title && (
            <h3
              style={{
                color: colors.title,
              }}
              className={content.title ? styles.subtitle : styles.subtitleEmpty}
            >
              {reactHtmlParser(content.title)}
            </h3>
          )}
        </div>
        <div className={styles.titleWrapperMobile}>
          {strippedTitle && (
            <h3
              style={{
                color: colors.title,
              }}
              className={content.title ? styles.subtitle : styles.subtitleEmpty}
            >
              {reactHtmlParser(content.title)}
            </h3>
          )}
        </div>

        <styled.Paragraph
          style={{
            color: colors.text,
          }}
          className={styles.text}
          linkColor={linkColor}
        >
          {reactHtmlParser(content.text)}
        </styled.Paragraph>
      </div>
    </div>
  );
};

// prop-types for TextBlock
const textBlockColorType = T.shape({
  title: T.string.isRequired,
  text: T.string.isRequired,
});
const textBlockContentType = T.shape({
  title: T.string.isRequired,
  text: T.string.isRequired,
});

const textBlockType = T.shape({
  colors: textBlockColorType.isRequired,
  content: textBlockContentType.isRequired,
});

TextBlock.propTypes = textBlockType.isRequired;

const Award = ({ img, href }) => (
  <a className={styles.awardLink} href={href}>
    <img className={styles.awardImg} src={img.src} alt={img.alt} />
  </a>
);

// prop-types for Award
const awardType = T.shape({
  href: T.string.isRequired,
  img: imgType.isRequired,
});

Award.propTypes = awardType.isRequired;

const About = ({ title, textBlocks, height }) => (
  <styled.Section height={height} className={styles.root}>
    <div className={styles.textSection}>
      <h2
        style={{
          color: title.color,
        }}
        className={styles.title}
      >
        {title.text}
      </h2>
      <div className={styles.textBlocks}>
        {textBlocks.content.map((textBlock, i) => (
          <TextBlock
            key={i}
            linkColor={title.color}
            colors={textBlocks.colors}
            content={textBlock}
          />
        ))}
      </div>
    </div>
  </styled.Section>
);

// prop-types for About

About.defaultProps = {
  height: '',
};

About.propTypes = {
  title: T.shape({
    color: T.string.isRequired,
    text: T.string.isRequired,
  }).isRequired,
  textBlocks: T.shape({
    colors: textBlockColorType.isRequired,
    content: T.arrayOf(textBlockContentType).isRequired,
  }).isRequired,
  awards: T.arrayOf(awardType).isRequired,
  height: T.string,
};

export default About;



// WEBPACK FOOTER //
// ./src/components/modules/About/About.js